<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputOpeningTimes" });
import { Button } from "../../../../../../../elements/index.js";
import FieldsetOpeningTime from "./FieldsetOpeningTime.svelte";
import { v4 as uuid } from "uuid";
export let values;
export let isDisabled = false;
export let isReadonly = false;
$: selectedDays = values.filter((value) => value.weekDay !== void 0).map((value) => value.weekDay);
const remove = (key) => {
    values = values.filter((value) => value.key !== key);
};
const add = () => {
    values = [
        ...values,
        {
            closingTime: void 0,
            key: uuid(),
            openingTime: void 0,
            weekDay: void 0
        }
    ];
};
</script>

{#each values as value}
    <FieldsetOpeningTime
        bind:value
        { isDisabled }
        { isReadonly }
        { remove }
        { selectedDays }
    />
{/each}

<Button
    label = 'Add an opening time'
    style = 'outline'
    icon = 'plus'
    align = 'left'
    size = 'xs'
    color = 'dark'
    on:click = { add }
    css = 'mb-3'
/>